import type { Nullable } from "../../../../typescript"
import type { EntityTypeId } from "../../entity/EntityTypeId.enum"

export default function toEntityTypeId9GLSL (
  list: Array<Nullable<EntityTypeId>>,
  entityTypeId: Nullable<EntityTypeId>,
) : Array<EntityTypeId> {
  const entityTypeIdList = [...list, entityTypeId]

  for (let i = 0; i < 9; i++) {
    entityTypeIdList[i] ||= (0 as EntityTypeId)
  }

  return entityTypeIdList as Array<EntityTypeId>
}